"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toolbarStyles = void 0;

var _getColor = require("../styleHelpers/getColor");

var _getSpacing = require("../styleHelpers/getSpacing");

var toolbarStyles = {
  gap: (0, _getSpacing.getSpacing)(2),
  divider: {
    width: 1,
    color: (0, _getColor.getColor)('borders', 'light')
  },
  item: {
    buttonTransition: [['background-color', '0.2s'], ['color', '0.2s']],
    iconTransition: [['transform', '0.2s']],
    iconScale: 1,
    size: '24px',
    borderRadius: 6,
    backgroundColor: 'transparent',
    color: (0, _getColor.getColor)('common', 'black'),
    hover: {
      backgroundColor: (0, _getColor.getColor)('brand', 'lightest'),
      color: (0, _getColor.getColor)('common', 'black')
    },
    focus: {
      backgroundColor: (0, _getColor.getColor)('brand', 'lightest'),
      color: (0, _getColor.getColor)('common', 'black')
    },
    active: {
      iconScale: 0.833333333,
      backgroundColor: (0, _getColor.getColor)('brand'),
      color: (0, _getColor.getColor)('common', 'white')
    }
  }
};
exports.toolbarStyles = toolbarStyles;